import { render, staticRenderFns } from "./ButtonPagination.vue?vue&type=template&id=12065a3c&"
import script from "./ButtonPagination.vue?vue&type=script&lang=js&"
export * from "./ButtonPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports